import { enUS } from 'date-fns/locale';

export const AvailableAppLocales = {
    enUS
};